import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { SearchService } from '@df/search/search.service';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';

export interface ISearchPopularContentBlock extends NICmsContentComponent.IData {
    header: string;
    top: boolean;
    texts: {
        text: string;
        link: string;
    }[];
    items: {
        image: string;
        title: string;
        link: string;
        hide: boolean;
    }[];
}

@Component({
    selector: 'search-popular-content-block',
    templateUrl: './search-popular-content-block.component.html',
    styleUrl: './search-popular-content-block.component.scss',
    standalone: true,
    imports: [DfImageDirective, GridModule, HrefComponent, ICmsClientModule, RouterModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<SearchPopularContentBlockComponent>({
    id: 'search-popular-content-block',
    block: {
        url: 'search-popular-content-block'
    },
    onDemandOnly: true,
    name: 'Search Popular Content Block',
    description: 'Content block used on the search outlet',
    fields: [
        <NICmsContentField.IField>{
            key: 'header',
            type: NICmsContentField.EFieldType.text,
            title: 'Header'
        },
        <NICmsContentField.IField>{
            key: 'top',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show Top Searches',
            default: false
        },
        <NICmsContentField.IRepeaterField>{
            key: 'items',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Items',
            itemName: 'Item',
            itemNameField: 'title',
            fields: [
                <NICmsContentField.IField>{
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image'
                },
                <NICmsContentField.IField>{
                    key: 'title',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Title'
                },
                <NICmsContentField.IField>{
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                <NICmsContentField.IField>{
                    key: 'hide',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Hide',
                    description: 'Hide item',
                    default: false
                }
            ],
            default: []
        }
    ]
})
export class SearchPopularContentBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: ISearchPopularContentBlock;

    protected searchService = inject(SearchService);

    get popularSearches(): string[] | undefined {
        return (<KlevuSearchService>this.searchService).webstorePopularTerms;
    }
}
